<template>
<div class="advantage-page" v-if="isSmallScreen===false">
<headers :imageSrc="imageSrc"/>
<mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<div class="advantage-page" v-else>
<headers :imageSrc="imageSrc"/>
<adva :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<advbottom/>
</div>
</template>
<script>
import headers from '../../components/headers.vue'
import advbottom from '../../components/advbottom.vue'
import Adva from '../../components/adva.vue'
import mains from '../../components/mains.vue'
import bottom from '../../components/bottom.vue'
export default {
  components: { headers, mains, Adva, bottom, advbottom },
  data () {
    return {
      imageSrc: '../assets/image/tlfdys.png',
      res1: '碳立方的优势',
      res2: '',
      res3: '',
      res4: '',
      res5: '../assets/2023logoImage/tlfdys.png',
      // res5: '../assets/advartages/dlzndx.png',
      isSmallScreen: false
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.res5 = '../assets/advartages/dlzndx.png'
      this.imageSrc = '../assets/image/tlfdysbanner.png'
    } else {
      this.isSmallScreen = false
      this.res5 = '../assets/2023logoImage/tlfdys.png'
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.res5 = '../assets/advartages/dlzndx.png'
      this.imageSrc = '../assets/image/tlfdysbanner.png'
    } else {
      this.isSmallScreen = false
    }
  }
}
</script>

<style scoped>

</style>
